import autocomplete from 'autocompleter';
import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import './autocomplete.scss';
import axios from 'axios';
import { find, hasClass, addClass } from '@fretadao/f-js-dom';
import { isPresent } from '@fretadao/f-js-utils';
import { autoClearableSetInterval } from '../../helpers';

application.register(
  'autocomplete',
  class extends Controller {
    static targets = ['input'];

    connect() {
      this.autocomplete(this.element);
    }

    autocomplete(element) {
      let url = this.data.get('url');
      let minLength = this.data.get('minLength') || 1;
      let debounceMs = this.data.get('debounceMs') || 0;
      let multiple = this.data.get('multiple') || this.inputTarget.multiple || false;

      if (url){
        return this.#flipAutoCompleteTarget(element, url, minLength, debounceMs, multiple, this.inputTarget);
      } 

      this.#addSelect2OnInput(this.inputTarget, multiple);
    }

    #flipAutoCompleteTarget(controllerElement, url, minLength, debounceMs, multiple, originInput) {
      let accessibleSelect2Fn = () => hasClass(originInput, 'select2-hidden-accessible');
      let intervalRepetition = 3;
      let intervalMsCount = 300;
      let localElement = controllerElement;

      autoClearableSetInterval(accessibleSelect2Fn, intervalRepetition, intervalMsCount, {
        onFullfillment: () => this.#setupSelect2(url, minLength, debounceMs, originInput, multiple),
        onLimit: () =>
          this.#setupAutoCompleter(localElement, url, minLength, debounceMs, originInput),
      });
    }

    #setupSelect2(url, minLength, debounceMs, originInput, multiple) {
      this.#setupPreselected2(originInput);

      $(originInput).select2({
        ajax: {
          url: url,
          delay: debounceMs,
          dataType: 'json',
          data: this.#buildSelect2Parameters(originInput),
          processResults: (data, _params) => {
            return { results: data.map(item => ({ id: item.value, text: item.label })) };
          },
          cache: true,
        },
        language: {
          inputTooShort: (args) => {
            let remainingChars = args.minimum - args.input.length;
            return `Digite pelo menos ${remainingChars} caractere(s) adicional(is).`;
          },
          noResults: () => 'Nenhum resultado encontrado.',
          searching: () => 'Buscando...',
          errorLoading: () => 'Não foi possível carregar os resultados.'
        },
        placeholder: 'Selecione uma opção',
        allowClear: true,
        multiple: multiple,
        minimumInputLength: minLength,
        width: '100%',
        selectionCssClass: 'not-select2-selection'
      })
    }

    #setupPreselected2(originInput) {
      if (isPresent(originInput.dataset.selected)) {
        let selectedItems = JSON.parse(originInput.dataset.selected);
        selectedItems.forEach(selectedItem => {
          let newOption = new Option(selectedItem.label, selectedItem.id, true, true);
          originInput.append(newOption);
        });
      }
    }

    #buildSelect2Parameters(originInput) {
      return (params) => {
        let scopedByName   = originInput.dataset.scopedBy;
        let scopingElement = $(`select[data-scope-name='${scopedByName}']`)
        let scopedIds;
        if(scopingElement.length > 0){
          scopedIds = scopingElement.select2('data').map(option => option.id);
        }

        return {
          query: params.term,
          filter_ids: scopedIds
        }
      }
    }

    #setupAutoCompleter(controllerElement, url, minLength, debounceMs, input) {
      autocomplete({
        minLength: minLength,
        debounceWaitMs: debounceMs,
        input: input,
        fetch: function(text, update) {
          axios.get(`${url}/?query=${text}`).then(function(response) {
            update(response.data);
          });
        },
        onSelect: function(item) {
          input.value = item.label;
          Object.keys(item).forEach(key => {
            if (key !== 'label') {
              let inputToFill = find(`[data-field=${key}]`, controllerElement);
              if (inputToFill && Array.isArray(item[key])) {
                inputToFill.length = 0;
                inputToFill.length = item[key].length;

                item[key].forEach((data, index) => {
                  inputToFill.options[index].text = data.label;
                  inputToFill.options[index].value = data.value;
                  inputToFill.options[index].dataset.result = JSON.stringify(data);
                });
              } else if (inputToFill) {
                inputToFill.value = item[key];
                inputToFill.text = item[key];
              }
            }
          });
        },
      });
    }

    #addSelect2OnInput(originInput, multiple) {
      $(originInput).select2({
        placeholder: 'Selecione uma opção',
        allowClear: true,
        multiple: multiple,
        width: '100%',
        selectionCssClass: 'not-select2-selection'
      })
    }
  }
);
